export const SET_BOOTH_DATA = 'SET_BOOTH_DATA'


export const setBoothHistory = data =>({
    type:SET_BOOTH_DATA,
    payload:data
});
